import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const SectionContainer = styled('section')`
  position: relative;
  margin-top: 24px;

  &:first-of-type {
    margin-top: 0;
  }
`;

const SectionHeaderRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
`;

/* Deliberately a step above the 14px/600 group labels inside a section
   (Include, Placement) so the two levels read apart. */
const SectionTitle = styled('h3')`
  margin: 0;
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
`;

export const HelperText = styled('div')`
  margin-top: 8px;
  font-family: 'Nunito Sans';
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const CopySection = ({
  id, title, headerControl, children,
}) => (
  <SectionContainer aria-labelledby={id}>
    <SectionHeaderRow>
      <SectionTitle id={id}>{title}</SectionTitle>
      {headerControl}
    </SectionHeaderRow>
    {children}
  </SectionContainer>
);

CopySection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  headerControl: PropTypes.node,
  children: PropTypes.node.isRequired,
};

CopySection.defaultProps = {
  headerControl: null,
};

export default CopySection;
